"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinatorSchemaSwitcher = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const react_1 = require("react");
const core_1 = require("@jsonforms/core");
function CombinatorSchemaSwitcher({ renderInfos, config, uischema, setSelectedIndex, selectedIndex, rootSchema, path, handleChange, data, }) {
    const appliedUiSchemaOptions = (0, lodash_merge_1.default)({}, config, uischema.options);
    const oneOfOptionType = appliedUiSchemaOptions.optionType;
    const labelMap = appliedUiSchemaOptions.subschemaTitleToLabelMap;
    const [dataForPreviousSchemas, setDataForPreviousSchemas] = (0, react_1.useState)({});
    const updateDataForPreviousSchemas = () => {
        setDataForPreviousSchemas({
            ...dataForPreviousSchemas,
            [selectedIndex]: data,
        });
    };
    const onChange = (combinatorIndex) => {
        updateDataForPreviousSchemas();
        setSelectedIndex(combinatorIndex);
        if (dataForPreviousSchemas[combinatorIndex]) {
            handleChange(path, dataForPreviousSchemas[combinatorIndex]);
        }
        else {
            handleCombinatorTypeChange({
                handleChange,
                combinatorIndex: combinatorIndex,
                renderInfos,
                path,
                rootSchema,
            });
        }
    };
    const options = renderInfos.map((renderInfo, index) => ({
        label: labelMap?.[renderInfo.label] ?? renderInfo.label,
        value: index,
    }));
    switch (oneOfOptionType) {
        case "button":
            return ((0, jsx_runtime_1.jsx)(antd_1.Radio.Group, { optionType: "button", buttonStyle: "solid", options: options, onChange: (e) => {
                    const combinatorIndex = e.target.value;
                    onChange(combinatorIndex);
                }, value: selectedIndex }));
        case "dropdown":
            return ((0, jsx_runtime_1.jsx)(antd_1.Select, { options: options, onChange: onChange, defaultValue: selectedIndex }));
        case "segmented":
            return ((0, jsx_runtime_1.jsx)(antd_1.Segmented, { options: options, onChange: onChange, value: selectedIndex }));
        case "radio":
        default:
            return ((0, jsx_runtime_1.jsx)(antd_1.Radio.Group, { options: options, onChange: (e) => {
                    const combinatorIndex = e.target.value;
                    onChange(combinatorIndex);
                }, value: selectedIndex }));
    }
}
exports.CombinatorSchemaSwitcher = CombinatorSchemaSwitcher;
function handleCombinatorTypeChange({ handleChange, renderInfos, combinatorIndex, path, rootSchema, }) {
    const newSchema = renderInfos[combinatorIndex]?.schema;
    if (!newSchema) {
        handleChange(path, {});
    }
    else {
        handleChange(path, (0, core_1.createDefaultValue)(newSchema, rootSchema));
    }
}
